'use client';

import Icon from '@ant-design/icons';
import { message } from 'antd';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { memo } from 'react';

import LogOutSvg from '@/components/Icon/svgs/logout.svg';
import { useModel } from '@/hooks/useModel';
import { useTranslation } from '@/i18n/client';
import { EVENT } from '@/utils/event';
import { ROUTER_PATH } from '@/utils/router';

import styles from '../../index.less';

interface LoginItemInterface {
  onItemClick?(): void;
}

function LoginItem(props: LoginItemInterface): JSX.Element | null {
  const { onItemClick: handleItemClick } = props;
  const { logout, isLogin } = useModel('auth-model', (model) => ({
    logout: model.logout,
    isLogin: model.isLogin
  }));

  const router = useRouter();

  const { t } = useTranslation();

  // antd 按钮初始样式异常（css in js 导致）
  if (isLogin === undefined) {
    return null;
  }

  if (!isLogin) {
    return (
      <div
        className={styles.menuItem}
        onClick={() => {
          handleItemClick?.();
          router.push(ROUTER_PATH.login);
        }}
      >
        <span className={styles.text}>{t('menu.noLoginTip')}</span>
      </div>
    );
  }

  return (
    <div
      className={classNames(styles.menuItem, '!text-[#FF7875]')}
      onClick={() => {
        dispatchEvent(new Event(EVENT.FOLD_MENU));
        logout().then(() => {
          message.success('Log out successfully');
          handleItemClick?.();
        });
      }}
    >
      <Icon className={styles.icon} component={LogOutSvg} />
      <span className={styles.text}>{t('menu.logout')}</span>
    </div>
  );
}

export default memo(LoginItem);
